// src/utils.js
import { DeviceTypes } from "./enums/DeviceTypes";

export const toPersianDigits = (number) => {
  const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  if (number == null) {
    return "";
  }
  return number
    .toString()
    .replace(/\d/g, (digit) => persianDigits[parseInt(digit)]);
};

export const toEnglishDigits = (number) => {
  const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  const englishDigits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
  if (number == null) {
    return "";
  }
  return number.replace(
    /[۰-۹]/g,
    (digit) => englishDigits[persianDigits.indexOf(digit)]
  );
};

export const getAssetPath = (path) => {
  const baseUrl = process.env.BASE_URL || "/";
  const normalizedPath = path.startsWith("/") ? path.slice(1) : path;
  return `${baseUrl}${normalizedPath}`;
};

export const getDeviceIcon = (type) => {
  const baseUrl = process.env.BASE_URL || "/";
  const deviceType = Object.values(DeviceTypes).find((dt) => dt.id === type);
  const iconPath = deviceType ? deviceType.icon : "/img/icons/home.webp";
  // Remove leading slash to avoid double slashes (e.g., //img)
  const normalizedIconPath = iconPath.startsWith("/")
    ? iconPath.slice(1)
    : iconPath;
  return `${baseUrl}${normalizedIconPath}`;
};

export const validatePhoneNumber = (phoneNumber) => {
  if (phoneNumber == null) {
    return "";
  }
  phoneNumber = phoneNumber.replace(/[^0-9]/g, "");
  if (phoneNumber.length > 0 && phoneNumber[0] !== "0") {
    phoneNumber = "0" + phoneNumber.slice(1);
  }
  if (phoneNumber.length > 11) {
    phoneNumber = phoneNumber.slice(0, 11);
  }
  return phoneNumber;
};

export const validatePin = (pin) => {
  if (pin == null) {
    return "";
  }
  pin = pin.replace(/[^0-9]/g, "");
  if (pin.length > 4) {
    pin = pin.slice(0, 4);
  }
  return pin;
};

export const reloadApp = () => {
  window.location.reload();
};
